// extracted by css-extract-rspack-plugin
export default {"listItem":"VacationApproverPicker_listItem__lKomr"};